export default {
  path: '/travel-documents/for-signature',
  name: 'DocumentsForSignature',
  component: () => import(/* webpackChunkName: "base" */ '../views/DocumentsForSignatureView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
